import { render, staticRenderFns } from "./value-blocks-slider.vue?vue&type=template&id=21b98f04&scoped=true&"
import script from "./value-blocks-slider.vue?vue&type=script&lang=js&"
export * from "./value-blocks-slider.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=21b98f04&scoped=true&lang=css&"
import style1 from "./value-blocks-slider.vue?vue&type=style&index=1&id=21b98f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b98f04",
  null
  
)

export default component.exports